/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://statefulcoders.com/product/material-dashboard-react
* Copyright 2025 Stateful Coders (https://https://statefulcoders.com)

Coded by https://statefulcoders.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 React base styles
import typography from "assets/theme/base/typography";
import breakpoints from "assets/theme/base/breakpoints";

// Material Dashboard 2 React helper functions
import pxToRem from "assets/theme/functions/pxToRem";

const { size } = typography;

const dialogTitle = {
  styleOverrides: {
    root: {
      padding: pxToRem(16),
      fontSize: size.xl,

      // Mobile optimizations
      [`@media (max-width: ${breakpoints.values.sm}px)`]: {
        padding: pxToRem(12),
        fontSize: size.lg,
      },

      [`@media (max-width: ${breakpoints.values.xs + 100}px)`]: {
        padding: pxToRem(8),
        fontSize: size.md,
      },
    },
  },
};

export default dialogTitle;
